import React, { forwardRef } from 'react';
import { closeSnackbar, SnackbarKey } from 'notistack';
import classNames from 'classnames';
import Svg from '@/src/components/UIKit/Svg.tsx';
import { NotificationStatus } from '@/src/utils/notifications';
import styles from './Notification.module.scss';

type NotificationProps = {
  id: SnackbarKey,
  title: string,
  body?: string | React.ReactNode,
  variant: NotificationStatus,
};

const notificationClassNameDict = {
  success: styles.success,
  warning: styles.warning,
  error: styles.error,
};

const Notification = forwardRef<HTMLDivElement, NotificationProps>(
  ({
    id, title, body, variant,
  }, ref) => {
    const notificationVariantClassName = notificationClassNameDict[variant] ?? styles.success;

    return (
      <div
        className={classNames(styles.notification, notificationVariantClassName)}
        ref={ref}
      >
        <div className={styles.notification__icon}>
          <Svg name={variant} />
        </div>
        <div className={styles.notification__content}>
          <p className={styles.notification__title}>{title}</p>
          {body && (
            <div className={styles.notification__body}>
              {body}
            </div>
          )}
        </div>
        <button
          type='button'
          onClick={() => closeSnackbar(id)}
          className={styles.notification__close}
        >
          <Svg name='close' />
        </button>
      </div>
    );
  },
);

export const notificationContent = ({
  id, title, body, variant,
}: NotificationProps) => (
  <Notification
    id={id}
    title={title}
    body={body}
    variant={variant}
  />
);
